import React, { useState } from "react";
import { List, Tag, Tooltip, Modal, Checkbox } from "antd";
import {
  RiArrowRightDoubleFill,
  RiBaseStationFill,
  RiDeleteBin2Line,
  RiGroupLine,
  RiRuler2Line,
} from "react-icons/ri";
import { getStationColor } from "../../utils/stationUtils";
import ProtectionZoneRadiusModal from "../ProtectionZoneRadiusModal";
import ProtectionZonePersonnelModal from "../ProtectionZonePersonnelModal";

const StationListItem = ({
  station,
  isPlaced,
  onStationClick,
  onRemoveStation,
  onUpdateRadius,
  onUpdateAllowedPersonnel,
  personnel,
  selectedStationId,
  setSelectedStationId,
  batchMode,
  isSelected,
  selectionOrder,
  onSelectionChange,
}) => {
  const [radiusDialogStation, setRadiusDialogStation] = useState(null);
  const [radiusConfirming, setRadiusConfirming] = useState(false);
  const [personnelDialogStation, setPersonnelDialogStation] = useState(null);
  const [personnelConfirming, setPersonnelConfirming] = useState(false);
  const stationColor = getStationColor(station.category);

  const isProtectionZone = station.category === "防護區";
  const showRadiusButton = isPlaced && isProtectionZone && !batchMode;

  const handleRadiusConfirm = async (stationId, radiusMeters) => {
    if (!onUpdateRadius) return;
    setRadiusConfirming(true);
    try {
      await onUpdateRadius(stationId, radiusMeters);
      setRadiusDialogStation(null);
    } finally {
      setRadiusConfirming(false);
    }
  };

  const handlePersonnelConfirm = async (stationId, allowedIds) => {
    if (!onUpdateAllowedPersonnel) return;
    setPersonnelConfirming(true);
    try {
      await onUpdateAllowedPersonnel(stationId, allowedIds);
      setPersonnelDialogStation(null);
    } finally {
      setPersonnelConfirming(false);
    }
  };

  const handleItemClick = () => {
    if (batchMode) {
      onSelectionChange(station.id);
    } else if (isPlaced) {
      setSelectedStationId(
        selectedStationId === station.id ? null : station.id,
      );
    } else {
      onStationClick(station);
    }
  };

  const listItem = (
    <List.Item
      style={{
        cursor: isPlaced ? "default" : "pointer",
        border: isPlaced
          ? "1px solid #d9d9d9"
          : batchMode && isSelected
            ? "2px solid #1890ff"
            : "1px solid #e8e8e8",
        borderRadius: 6,
        marginBottom: 8,
        padding: "8px 12px",
        backgroundColor: isPlaced
          ? "#fafafa"
          : batchMode && isSelected
            ? "#e6f7ff"
            : "#ffffff",
        transition: "all 0.2s ease",
        opacity: isPlaced ? 1 : 1,
        position: "relative",
      }}
      onClick={handleItemClick}
      onMouseEnter={(e) => {
        if (isPlaced) {
          e.currentTarget.style.backgroundColor = "#f0f0f0";
          e.currentTarget.style.borderColor = "#bfbfbf";
        } else {
          e.currentTarget.style.backgroundColor =
            batchMode && isSelected ? "#e6f7ff" : "#f5f5f5";
          if (!batchMode || !isSelected) {
            e.currentTarget.style.borderColor = "#d9d9d9";
          }
          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
        }
      }}
      onMouseLeave={(e) => {
        if (isPlaced) {
          e.currentTarget.style.backgroundColor = "#fafafa";
          e.currentTarget.style.borderColor = "#d9d9d9";
        } else {
          e.currentTarget.style.backgroundColor =
            batchMode && isSelected ? "#e6f7ff" : "#ffffff";
          if (!batchMode || !isSelected) {
            e.currentTarget.style.borderColor = "#e8e8e8";
          }
          e.currentTarget.style.boxShadow = "none";
        }
      }}
      actions={
        batchMode
          ? [
              <Checkbox
                key="checkbox"
                checked={isSelected}
                onClick={(e) => e.stopPropagation()}
                onChange={() => onSelectionChange(station.id)}
              />,
            ]
          : !isPlaced
            ? [
                <RiArrowRightDoubleFill
                  key="add"
                  style={{
                    color: "#595959",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                />,
              ]
            : []
      }
    >
      {batchMode && isSelected && selectionOrder && (
        <div
          style={{
            position: "absolute",
            top: -8,
            left: -8,
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: "#1890ff",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            fontWeight: 600,
            border: "2px solid white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            zIndex: 10,
          }}
        >
          {selectionOrder}
        </div>
      )}
      <List.Item.Meta
        title={
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                minWidth: 0,
              }}
            >
              <Tag
                color={stationColor.primary}
                style={{
                  margin: 0,
                  fontSize: "18px",
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <RiBaseStationFill />
              </Tag>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Tooltip title={station.name || "未命名基站"}>
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "block",
                    }}
                  >
                    {station.name || "未命名基站"}
                  </span>
                </Tooltip>
                {station.device_id && (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#8c8c8c",
                      display: "block",
                    }}
                  >
                    裝置 ID: {station.device_id}
                  </span>
                )}
              </div>
            </div>
            {isPlaced && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <Tooltip title="從畫布移除">
                    <RiDeleteBin2Line
                      style={{
                        color: "#595959",
                        fontSize: "24px",
                        cursor: "pointer",
                        padding: "4px",
                        borderRadius: "4px",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#59595920";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        Modal.confirm({
                          title: "確定要從畫布移除此基站嗎？",
                          okText: "確定",
                          cancelText: "取消",
                          okType: "danger",
                          onOk: () => onRemoveStation(station),
                        });
                      }}
                    />
                  </Tooltip>
                  {showRadiusButton && (
                    <Tooltip title="設定半徑">
                      <RiRuler2Line
                        style={{
                          color: "#595959",
                          fontSize: "24px",
                          cursor: "pointer",
                          padding: "4px",
                          borderRadius: "4px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#59595920";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setRadiusDialogStation(station);
                        }}
                      />
                    </Tooltip>
                  )}
                  {showRadiusButton && (
                    <Tooltip title="設定人員白名單">
                      <RiGroupLine
                        style={{
                          color: "#595959",
                          fontSize: "24px",
                          cursor: "pointer",
                          padding: "4px",
                          borderRadius: "4px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#59595920";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPersonnelDialogStation(station);
                        }}
                      />
                    </Tooltip>
                  )}
                </div>
              </div>
            )}
          </div>
        }
        description={null}
      />
      <ProtectionZoneRadiusModal
        open={radiusDialogStation != null}
        station={radiusDialogStation}
        onClose={() => setRadiusDialogStation(null)}
        onConfirm={handleRadiusConfirm}
        confirming={radiusConfirming}
      />
      <ProtectionZonePersonnelModal
        open={personnelDialogStation != null}
        station={personnelDialogStation}
        personnel={personnel}
        onClose={() => setPersonnelDialogStation(null)}
        onConfirm={handlePersonnelConfirm}
        confirming={personnelConfirming}
      />
    </List.Item>
  );

  return batchMode ? (
    <Tooltip title="點擊選擇/取消選擇">{listItem}</Tooltip>
  ) : isPlaced ? (
    listItem
  ) : (
    <Tooltip title="點擊加入畫布">{listItem}</Tooltip>
  );
};

export default StationListItem;
